import React from 'react';
import ExtendedModulePage from './ExtendedModulePage';
export default function ExamGroupsPage(){ return <ExtendedModulePage moduleKey="exam-groups"/>; }
